import { type RegisteredApp } from '~/shared/appContract'

/**
 * Arc's public entrypoint.
 *
 * Nothing here may import Arc's routes, nav, or pages statically: this module lands in the entry
 * chunk (the registry reads every app's id and copy on first paint), so a static import would put
 * Arc's pages there too. The dynamic `import()`s below are what keep Arc a chunk of its own, and both
 * go through `ArcChunk` so that chunk is one rather than two. See Atlas ADR-0019 and Atlas ADR-0021.
 *
 * `as const satisfies` preserves literal ids and flag names for the registry's derived unions
 * (Atlas ADR-0028).
 */
export const arcApp = {
  id: 'arc',
  name: 'Arc',
  description:
    'Analytics for revenue impact, provider coaching, and encounter history',
  loadRoutes: () =>
    import('./ArcChunk').then(({ ArcRoutes, arcSlice }) => ({
      Component: ArcRoutes,
      reducer: arcSlice.reducer,
    })),
  loadNav: () =>
    import('./ArcChunk').then(({ ArcNav }) => ({ Component: ArcNav })),
  flags: [
    'frontend_arc_overview_page_enabled',
    'frontend_arc_clinicians_page_enabled',
    'frontend_arc_billing_window_default_enabled',
    'frontend_arc_overview_clinicians_enabled',
    'frontend_arc_patient_status_filter_enabled',
  ],
} as const satisfies RegisteredApp<'arc'>
